import React from 'react';
import { ArrowDownIcon, ArrowRightIcon } from 'lucide-react';
import { roomExtras, roomPath, usageSteps } from '../data/content';
import { Eyebrow, SectionTitle } from './ui/Section';
export function HowItWorks() {
  return <section className="mx-auto max-w-5xl px-4 py-12 md:py-16" data-id="element-151" data-mp="3pztabxs0gz7l">
      <Eyebrow data-id="element-152" data-mp="3tzjxlribwx7d">🧭 Así se usa</Eyebrow>
      <SectionTitle data-id="element-153" data-mp="3u0v4i072ml2p">
        No tenés que <span className="text-sky-600" data-id="element-154" data-mp="3u1wo4t25kfw1">diseñar el mueble desde cero.</span>
      </SectionTitle>

      <ol className="mt-8 grid gap-3 md:grid-cols-4" data-id="element-155" data-mp="lmmft37o6eft">
        {usageSteps.map(([number, title, text], index) => <li key={number} className="relative flex flex-col rounded-2xl border border-slate-200 bg-white p-5 shadow-sm" data-id="element-156" data-mp="cs82352sfbyt" data-mpi={index}>
            <span className="text-3xl font-black leading-none text-sky-600" data-id="element-157" data-mp="gs0anhs6li46">{number}</span>
            <p className="mt-2 text-sm font-black uppercase leading-tight text-slate-900 md:text-base" data-id="element-158" data-mp="14hkyof36z5kb">
              {title}
            </p>
            <p className="mt-1 text-sm font-semibold leading-snug text-slate-600" data-id="element-159" data-mp="2rlnzfhbzmuzz">{text}</p>
            {index < usageSteps.length - 1 && <>
                <ArrowRightIcon className="absolute -right-3 top-1/2 hidden h-5 w-5 -translate-y-1/2 text-sky-600 md:block" aria-hidden="true" data-id="element-160" data-mp="2mo5zggfy7q44" />
                <ArrowDownIcon className="absolute -bottom-2.5 left-1/2 h-5 w-5 -translate-x-1/2 text-sky-600 md:hidden" aria-hidden="true" data-id="element-161" data-mp="2wj6b3fhe3obo" />
              </>}
          </li>)}
      </ol>

      <div className="mt-8 rounded-2xl border border-slate-200 bg-white p-5 shadow-sm md:p-8" data-id="element-162" data-mp="3kav83955p0yy">
        <p className="text-center text-[11px] font-extrabold uppercase tracking-[.16em] text-slate-500 md:text-sm" data-id="element-163" data-mp="3faqp9cgrzu5k">
          El camino completo
        </p>
        <div className="mt-4 flex flex-col items-center justify-center gap-2 md:flex-row md:flex-wrap" data-id="element-164" data-mp="1pwkfcplfxmnw">
          {roomPath.map((room, index) => <React.Fragment key={room} data-id="element-165" data-mp="3l00hp1frssel" data-mpi={index}>
              {index > 0 && <>
                  <ArrowDownIcon className="h-4 w-4 text-sky-600 md:hidden" aria-hidden="true" data-id="element-166" data-mp="3py1y1eltadmd" />
                  <ArrowRightIcon className="hidden h-4 w-4 text-sky-600 md:block" aria-hidden="true" data-id="element-167" data-mp="3tznhxjwrjs62" />
                </>}
              <span className="whitespace-nowrap rounded-lg bg-sky-600 px-3 py-1.5 text-sm font-black uppercase text-white md:text-base" data-id="element-168" data-mp="2vfaehs472o7">
                {room}
              </span>
            </React.Fragment>)}
        </div>
        <p className="mt-5 text-center text-xs font-bold uppercase tracking-wide text-slate-500" data-id="element-169" data-mp="cpp360kyy2zg">
          Y además:
        </p>
        <p className="mt-1 text-center text-sm font-black uppercase text-slate-900 md:text-base" data-id="element-170" data-mp="lkvax53suv4m">
          {roomExtras}
        </p>
      </div>

      <p className="mt-5 rounded-2xl bg-slate-900 px-5 py-4 text-center text-sm font-semibold leading-relaxed text-slate-200 md:text-base" data-id="element-171" data-mp="ql9mgx4m0n7e">
        <b className="text-sky-300" data-id="element-172" data-mp="15m6q2jldmgnr">Medidas + cortes + armado + terminación + revisión.</b>{' '}
        Todo organizado dentro del mismo sistema.
      </p>
    </section>;
}